var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8993 10.6736L13.1117 1.38414C13.0423 1.26535 12.9505 1.16851 12.8441 1.10168C12.7377 1.03486 12.6197 1 12.5 1C12.3803 1 12.2623 1.03486 12.1559 1.10168C12.0495 1.16851 11.9577 1.26535 11.8883 1.38414L7.079 10.7185C6.41142 12.0317 6.03929 13.5359 6 15.0798C6 17.1804 6.68482 19.1949 7.90381 20.6802C9.12279 22.1656 10.7761 23 12.5 23C14.2239 23 15.8772 22.1656 17.0962 20.6802C18.3152 19.1949 19 17.1804 19 15.0798C18.9586 13.5185 18.5788 11.9983 17.8993 10.6736ZM12.5 21.24C11.1598 21.2376 9.87498 20.5879 8.92729 19.4331C7.97961 18.2784 7.44635 16.7129 7.44444 15.0798C7.48357 13.8494 7.78689 12.6529 8.32411 11.6099L8.99939 10.2987L16.2751 19.164C15.8024 19.8162 15.2215 20.3386 14.5707 20.6967C13.9199 21.0547 13.2141 21.2393 12.5 21.24Z",
    fill: "#564AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityLogo);
export default __webpack_public_path__ + "static/media/humidityLogo.ef4937b7b3d0c99da6afa890cd1ba76c.svg";
export { ForwardRef as ReactComponent };